export const localizations = {
  eng: {
    client_id: 'Client ID',
    cabinet: 'Cabinet',
    manage: 'Manage',
    device: 'Device',
    connection_error: 'Connection error',
    auth_error: 'Session expired',
    auth_error_message: 'Please restart the app',
    support: 'Support',
    referral_prompt: 'Have a referral code?',
    referral_placeholder: 'Your code',
    referral_apply: 'Apply',
    referral_applied: 'Applied',
    referral_error: 'Invalid code',
  },
  rus: {
    client_id: 'ID клиента',
    cabinet: 'Кабинет',
    manage: 'Управлять',
    device: 'Устройство',
    connection_error: 'Ошибка подключения',
    auth_error: 'Сессия истекла',
    auth_error_message: 'Перезапустите приложение',
    support: 'Поддержка',
    referral_prompt: 'Есть реферальный код?',
    referral_placeholder: 'Ваш код',
    referral_apply: 'Применить',
    referral_applied: 'Код применен',
    referral_error: 'Неверный код',
   },
};

export function setLang(lang) {
  if (!localizations.hasOwnProperty(lang)) {
    lang = 'eng';
  }
  window.strings = localizations[lang];
}

window.localizations = localizations;
window.strings = localizations['rus'];

